import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22AccessibilityMenu.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/OpenDyslexic-Regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/OpenDyslexic-Bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/OpenDyslexic-Italic.woff2%22,%22weight%22:%22400%22,%22style%22:%22italic%22}]}],%22variableName%22:%22openDyslexic%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'openDyslexic', 'openDyslexic Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
